import React from "react"
import { Card, Button } from "react-bootstrap"
import { reactLocalStorage } from "reactjs-localstorage";
import {
  FaCommentAlt,
  FaEnvelope,
  FaWhatsapp,
  FaSms,
  FaUser,
  FaClock,
  FaTrashAlt,
  FaEdit,
} from "react-icons/fa"
import Parse from 'html-react-parser';

import NoteAPI from "../../../api/NoteAPI";
import Display from "../../../util/Display";
import Util from "../../../util/Util";
import Const from "../../../util/Constants";
import WhatsAppAPI from "../../../api/WhatsAppAPI";
import EmailAPI from "../../../api/EmailAPI";
import SmsAPI from "../../../api/SmsAPI";

class ActivityTab extends React.Component {
  constructor(props) {
    super(props);
    this.models = reactLocalStorage.getObject(Const.Model);

    this.NoteUpdate = Util.isAllow(this.models.note.permission, Const.PermUpdate);
    this.NoteDelete = Util.isAllow(this.models.note.permission, Const.PermDelete);

    this.EmailUpdate = Util.isAllow(this.models.email.permission, Const.PermUpdate);
    this.EmailDelete = Util.isAllow(this.models.email.permission, Const.PermDelete);

    this.SmsUpdate = Util.isAllow(this.models.sms.permission, Const.PermUpdate);
    this.SmsDelete = Util.isAllow(this.models.sms.permission, Const.PermDelete);

    this.WhatsAppUpdate = Util.isAllow(this.models.whatsapp.permission, Const.PermUpdate);
    this.WhatsAppDelete = Util.isAllow(this.models.whatsapp.permission, Const.PermDelete);

    this.permissions = {
      note: Util.isAllow(this.models.note.permission, Const.PermView),
      whatsapp: Util.isAllow(this.models.whatsapp.permission, Const.PermView),
      email: Util.isAllow(this.models.email.permission, Const.PermView),
      sms: Util.isAllow(this.models.sms.permission, Const.PermView),
    };

    this.state = {
      inApiCall: true,
      activities: [],
    };
  }

  componentDidMount() {
    this.loadActivities(this.props.id);
  }
  
  UNSAFE_componentWillReceiveProps(props) {
    if (props.id !== this.props.id) {
      this.setState({ inApiCall: true, activities: [] });
      this.loadActivities(props.id);
    }
  }
  
  loadActivities = (id) => {
    this.activities = [];
    this.pendingCalls = 0;

    if (this.permissions.note) {
      this.pendingCalls++;
      NoteAPI.getInnerList(this.props.type, id, res =>
        this.onReceived(res, 'note')
      );
    }

    if (this.permissions.whatsapp) {
      this.pendingCalls++;
      WhatsAppAPI.getInnerList(this.props.type, id, res =>
        this.onReceived(res, 'whatsapp')
      );
    }

    if (this.permissions.email) {
      this.pendingCalls++;
      EmailAPI.getInnerList(this.props.type, id, res =>
        this.onReceived(res, 'email')
      );
    }

    if (this.permissions.sms) {
      this.pendingCalls++;
      SmsAPI.getInnerList(this.props.type, id, res =>
        this.onReceived(res, 'sms')
      );
    }

    if (this.pendingCalls === 0) {
      this.setState({ inApiCall: false });
    }
  };
  
  onReceived = (res, type) => {
    const mapped = (res.data || []).map(item => ({
      id: item.id,
      type,
      content:
        type === "note" ? Parse(Display.FieldValue(item, 'text', this.models.note.fields)) : item.text ||
        item.message ||
        item.body ||
        '-',
      createdBy: Display.ModelLabelValue('user', item.created_by),
      date: Util.serverStringToDisplayDateTime(item.created_date),
      created_date: item.created_date,
      _actual_item: {
        ...item
      }
    }));

    this.activities = [...this.activities, ...mapped];
    this.pendingCalls--;

    if (this.pendingCalls === 0) {
      this.setState({
        inApiCall: false,
        activities: this.activities.sort(
          (a, b) => new Date(b.created_date) - new Date(a.created_date)
        ),
      });
    }
  };
  
  getIcon = (type) => {
    switch (type) {
      case 'note': return <FaCommentAlt color="#8b5cf6" />;
      case 'whatsapp': return <FaWhatsapp color="#22c55e" />;
      case 'email': return <FaEnvelope color="#3b82f6" />;
      case 'sms': return <FaSms color="#6366f1" />;
      default: return null;
    }
  };

  getLabel = (type) => {
    switch (type) {
      case 'note': return 'Note';
      case 'whatsapp': return 'WhatsApp';
      case 'email': return 'Email';
      case 'sms': return 'SMS';
      default: return '';
    }
  };

  canEdit = (type) => {
    switch (type) {
      case 'note': return this.NoteUpdate;
      case 'email': return this.EmailUpdate;
      case 'sms': return this.SmsUpdate;
      case 'whatsapp': return this.WhatsAppUpdate;
      default: return false;
    }
  };

  canDelete = (type) => {
    switch (type) {
      case 'note': return this.NoteDelete;
      case 'email': return this.EmailDelete;
      case 'sms': return this.SmsDelete;
      case 'whatsapp': return this.WhatsAppDelete;
      default: return false;
    }
  };

  onDelete = (item, type) =>
    Util.confirmAlert(
      "Delete",
      `Are you sure you want to delete this ${type}?`,
      "Delete",
      "No",
      () => {
        this.setState({ inApiCall: true });

        const apiMap = {
          note: NoteAPI,
          email: EmailAPI,
          sms: SmsAPI,
          whatsapp: WhatsAppAPI,
        };


        apiMap[type].delete(
          item.id,
          () => {
            Util.showNotification("Success", "Deleted successfully", "success");
            this.loadActivities(this.props.id);
          },
          this.onFail
        );
      }
    );

  render() {
    const { activities } = this.state;

    const notes = activities.filter(a => a.type === 'note');
    const whatsapp = activities.filter(a => a.type === 'whatsapp');
    const emails = activities.filter(a => a.type === 'email');
    const sms = activities.filter(a => a.type === 'sms');

    return (
      <div style={{ marginTop: 16 }}>

        {/* SUMMARY */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 24 }}>
          {[
            { label: "Notes", count: notes.length, icon: <FaCommentAlt />, color: "#8b5cf6", bg: "#faf5ff", permission: this.permissions.note },
            { label: "WhatsApp", count: whatsapp.length, icon: <FaWhatsapp />, color: "#22c55e", bg: "#f0fdf4", permission: this.permissions.whatsapp },
            { label: "Emails", count: emails.length, icon: <FaEnvelope />, color: "#3b82f6", bg: "#eff6ff", permission: this.permissions.email },
            { label: "SMS", count: sms.length, icon: <FaSms />, color: "#6366f1", bg: "#eef2ff", permission: this.permissions.sms },
          ].map((item, i) => (
            item.permission ? <Card key={i} style={{ border: "none", background: item.bg }}>
              <Card.Body className="text-center">
                <div style={{
                  width: 40, height: 40, borderRadius: "50%",
                  background: item.color, color: "#fff",
                  display: "inline-flex", alignItems: "center", justifyContent: "center",
                  marginBottom: 8
                }}>
                  {item.icon}
                </div>
                <div style={{ fontSize: 12, color: "#6b7280" }}>{item.label}</div>
                <div style={{ fontSize: 20, fontWeight: 700, color: item.color }}>{item.count}</div>
              </Card.Body>
            </Card> : null
          ))}
        </div>

        {/* ACTIVITY LIST */}
        <div style={{ display: "grid", gap: 12 }}>
          {activities.length ? activities.map((item, i) => (
            <div key={i} style={{
              background: "#fff",
              border: "1px solid #e5e7eb",
              borderRadius: 8,
              padding: 16
            }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  {this.getIcon(item.type)}
                  <strong>{this.getLabel(item.type)}</strong>
                </div>
                <span style={{ fontSize: 12, color: "#6b7280" }}>
                  <FaClock /> {item.date}
                </span>
              </div>

              <div style={{ fontSize: 14, color: "#374151", marginBottom: 12 }}>
                {item.content}
              </div>

              <div style={{
                display: "flex",
                justifyContent: "space-between",
                borderTop: "1px solid #f3f4f6",
                paddingTop: 8
              }}>
                <span style={{ fontSize: 12, color: "#6b7280" }}>
                  <FaUser /> {item.createdBy}
                </span>

                <div style={{ display: "flex", gap: 8 }}>
                  {this.canEdit(item.type) ? (
                    <Button
                      size="sm"
                      variant="outline-primary"
                      onClick={() => this.props.edit(item._actual_item, item.type)}
                    >
                      <FaEdit size={12} /> Edit
                    </Button>
                  ): null}

                  {this.canDelete(item.type) ? (
                    <Button
                      size="sm"
                      variant="outline-danger"
                      onClick={() => this.onDelete(item._actual_item, item.type)}
                    >
                      <FaTrashAlt size={12} /> Delete
                    </Button>
                  ): null}
                </div>
              </div>
            </div>
          )) : (
            <div style={{
              padding: 40,
              textAlign: "center",
              background: "#f8fafc",
              border: "1px dashed #d1d5db",
              borderRadius: 8
            }}>
              No activity found
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ActivityTab
